import { render, staticRenderFns } from "./StandaloneLayout.vue?vue&type=template&id=04d7ebd2&scoped=true"
import script from "./StandaloneLayout.vue?vue&type=script&lang=js"
export * from "./StandaloneLayout.vue?vue&type=script&lang=js"
import style0 from "./StandaloneLayout.vue?vue&type=style&index=0&id=04d7ebd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7ebd2",
  null
  
)

export default component.exports